import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Title from '../../components/title/Title';
import Rotas from './Rotas';
import RotasRev from './RotasRev';
import Dashboard from './dashboard/Dashboard';
import './Painel.scss';

const Painel = props => {

    const history = useHistory();
    const params = useParams();
    const profile = useSelector(state => state.auth.profile);
    const [moduleName, setModuleName] = useState('Home');
    const [modulo, setModulo] = useState(<Dashboard />);

    const renderPrimeiroModulo = useCallback(() => {
        const modulo = params.modulo;
        const _Rotas = profile.grupo.code === 'rev' ? RotasRev : Rotas;
        const rota = _Rotas.find((menu) => {
            if (menu.subitems.length > 0) {
                return menu.subitems.find(item => {
                    return item.rota === modulo;
                })
            } else {
                return menu.rota === modulo;
            }
        });

        if (rota.subitems.length > 0) {
            const subrota = rota.subitems.find(item => {
                return item.rota === modulo;
            });
            if (subrota) {
                setModulo(subrota.component);
            }
        } else {
            setModulo(rota.component);
        }
    }, [params.modulo]);

    useEffect(() => {
        if (profile) {
            if (profile.status <= 2) {
                history.push('/cadastro');
            }
        }
        renderPrimeiroModulo();
    }, [profile, history, renderPrimeiroModulo]);

    const callModule = (item) => {
        if (item.rota && item.rota !== "") {
            history.push(`/painel/${item.rota}`);
            setModuleName(item.label);
            setModulo(item.component);
        }
    };

    const renderModulo = () => {
        return (
            <>
                {modulo}
            </>
        );
    }

    const renderMenu = () => {
        return Rotas.map((menu, index) => {
            return (
                <li className="item" key={index}>
                    <div onClick={() => { callModule(menu) }}>
                        <span className="material-icons">{menu.icon}</span> {menu.label}
                    </div>
                    {renderSubMenu(menu)}
                </li>
            )
        })
    }

    const renderMenuRev = () => {
        return RotasRev.map((menu, index) => {
            return (
                <li className="item" key={index}>
                    <div onClick={() => { callModule(menu) }}>
                        <span className="material-icons">{menu.icon}</span> {menu.label}
                    </div>
                    {renderSubMenu(menu)}
                </li>
            )
        })
    }

    const renderSubMenu = menu => {
        if (menu.subitems.length > 0) {
            return (
                <ul className="subMenuPainel">
                    {menu.subitems.map((item, index) => (
                        <li className="item" key={index}>
                            <div className={params.modulo === item.rota ? 'active' : ''} onClick={() => { callModule(item) }}>{item.label}</div>
                        </li>
                    ))}
                </ul>
            )
        }
    }

    const comLarguraTotal = _ => {
        return (params.modulo === 'recebimentos' || params.modulo === 'faturamentos') && params.acao ==='form';
    }

    return (
        <div className="background">
            <Title title="Painel administrativo" subtitle={moduleName} />
            {/* <pre>{JSON.stringify(profile.grupo.code,null,2)}</pre> */}
            <div className="areaMenuPainel">
                <ul className="menuPainel">
                    {profile.grupo.code === "rev" && renderMenuRev()}
                    {profile.grupo.code === "adm" && renderMenu()}
                </ul>
            </div>
            <div className={`container painel ${comLarguraTotal() && 'fluido'}`}>
                <div className="content">
                    <div className="row">
                        {/* <div className="col1">
                            <ul className="menuPainel">
                                {renderMenu()}
                            </ul>
                        </div> */}
                        <div className="col2">
                            <div className="modulo">
                                {renderModulo()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Painel;